import React, { useState, useEffect, useContext } from 'react';
import styles from './styles.module.css';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { loadPopup } from '../Utils/LoginUtils';
import { green, red } from '@mui/material/colors';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import MicOutlinedIcon from '@mui/icons-material/MicOutlined';
import VideocamOffOutlinedIcon from '@mui/icons-material/VideocamOffOutlined';
import MicOffOutlinedIcon from '@mui/icons-material/MicOffOutlined';
import { Store } from '../App';

const CameraMicTest = ({ style }) => {
  const [cameraStream, setCameraStream] = useState(null);
  const [micStream, setMicStream] = useState(null);
  const { isCameraActivestore, setIsCameraActivestore, isMicActivestore, setIsMicActivestore, data } = useContext(Store);

  useEffect(() => {
    if (!isCameraActivestore && data) {
      loadPopup("camera disabled...");
    }
  }, [isCameraActivestore]);



  const startCameraTest = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      setCameraStream(stream);
      setIsCameraActivestore(true);


      stream.getVideoTracks()[0].onended = () => {
        setCameraStream(null);
        setIsCameraActivestore(false);
      };
    } catch (error) {
      loadPopup('Permission denied. Please enable camera access in your browser settings and try again.');
      console.error('Error accessing camera:', error);
    }
  };

  const startMicTest = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      setMicStream(stream);
      setIsMicActivestore(true);
      stream.getAudioTracks()[0].onended = () => {
        setMicStream(null);
        setIsMicActivestore(false);
      };
    } catch (error) {
      loadPopup('Permission denied. Please enable microphone access in your browser settings and try again.');
      console.error('Error accessing microphone:', error);
    }
  };
  console.log("isMicActivestore" + isMicActivestore + " isCameraActivestore" + isCameraActivestore);
  return (
    <div className={styles.container} style={{ border: isCameraActivestore && isMicActivestore && !style ? '1px solid green' : !style ? '1px solid #dddada' : 'none', width: style ? '165px' : '', margin: style ? '0px' : '', padding: style ? '0px' : '' }}>
      <div className={styles.item}>
        {!isCameraActivestore ? (
          <FormControlLabel
            control={<Switch checked={isCameraActivestore} onChange={startCameraTest} />}
            label={isCameraActivestore ? <CameraAltOutlinedIcon sx={{ color: green[500] }} fontSize="large" /> : <VideocamOffOutlinedIcon sx={{ color: '#ef6258' }} fontSize="large" />}
            className={isCameraActivestore ? styles.activeSwitch : ''}
          />
        ) : <CameraAltOutlinedIcon sx={{ color: green[500] }} fontSize="large" /> }

      </div>

      <div className={styles.item}>
      {!isMicActivestore ? (
        <FormControlLabel
          control={<Switch checked={isMicActivestore} onChange={startMicTest} />}
          label={isMicActivestore ? <MicOutlinedIcon sx={{ color: green[500] }} fontSize="large" /> : <MicOffOutlinedIcon sx={{ color: '#ef6258' }} fontSize="large" />}
          className={isMicActivestore ? styles.activeSwitch : ''}
        />
      ):<MicOutlinedIcon sx={{ color: green[500] }} fontSize="large" /> }
      </div>
    </div>
  );
};

export default CameraMicTest;
